import { useState, useEffect, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import SubmissionCard from "@/components/SubmissionCard";
import SubmissionDrawer from "@/components/SubmissionDrawer";
import StatsGrid from "@/components/StatsGrid";
import { toast } from "sonner";
import { MegaphoneSimple } from "@phosphor-icons/react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function BrandDashboard() {
  const [subs, setSubs] = useState([]);
  const [stats, setStats] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [filter, setFilter] = useState("pending");

  const load = useCallback(async () => {
    try {
      const [s, st] = await Promise.all([
        api.get("/submissions"),
        api.get("/stats"),
      ]);
      setSubs(s.data);
      setStats(st.data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const filtered = filter === "all" ? subs : subs.filter((s) => s.status === filter);

  return (
    <div className="animate-fade-in-up">
      <div className="mb-8">
        <h1 className="font-heading font-black text-4xl">Review Queue</h1>
        <p className="text-zinc-400 mt-1">Approve or send feedback on influencer submissions.</p>
      </div>

      <StatsGrid stats={stats} role="brand" />

      <Tabs value={filter} onValueChange={setFilter} className="mt-8">
        <TabsList className="bg-zinc-900 border border-white/10" data-testid="brand-filter-tabs">
          <TabsTrigger value="pending" data-testid="filter-pending">Pending</TabsTrigger>
          <TabsTrigger value="approved" data-testid="filter-approved">Approved</TabsTrigger>
          <TabsTrigger value="rejected" data-testid="filter-rejected">Rejected</TabsTrigger>
          <TabsTrigger value="all" data-testid="filter-all">All</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="mt-6">
        {filtered.length === 0 ? (
          <div className="rounded-xl border border-dashed border-white/10 p-12 text-center">
            <MegaphoneSimple size={40} weight="duotone" className="mx-auto text-zinc-600 mb-3" />
            <p className="text-zinc-400">No submissions in this filter.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((s) => (
              <SubmissionCard key={s.id} submission={s} onClick={() => setActiveId(s.id)} />
            ))}
          </div>
        )}
      </div>

      <SubmissionDrawer
        submissionId={activeId}
        open={!!activeId}
        onClose={() => setActiveId(null)}
        role="brand"
        onUpdated={load}
      />
    </div>
  );
}
